import _extends from '@babel/runtime/helpers/esm/extends';
import React, { forwardRef } from 'react';
import { Box } from '@chakra-ui/react';

/** A Box with some opinionated defaults */
var Card = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    borderRadius: "xl",
    padding: 8,
    bg: "scheme.bgPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  Card.displayName = 'Card';
}

export { Card };
